export const TYPE = 'release'
export const API_ROOT = {
  debug: 'https://api-dev.linapp.compassbioinfo.com/api/',
  release: 'https://api.linapp.compassbioinfo.com/api/'
}[TYPE]



// WEBPACK FOOTER //
// ./src/api/config.js